/**
 * useAttachDomain hook
 *
 * TanStack mutation wrapping `domainsApi.attachDomain`. Invalidates
 * `['domains']` (attachment changes the row's `siteId`) and the affected
 * site's detail key so per-site domain UI reflects the new state.
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { domainsApi } from '@/api/domainsApi';

interface AttachInput {
  domainId: string;
  siteId: string;
}

export function useAttachDomain() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: AttachInput) =>
      domainsApi.attachDomain(input.domainId, input.siteId),
    onSuccess: (_, { siteId }) => {
      queryClient.invalidateQueries({ queryKey: ['domains'] });
      queryClient.invalidateQueries({ queryKey: ['sites', siteId] });
    },
  });
}
